module.exports = __webpack_public_path__ + "images/9689461dca535a0f6a2e6284820fa170.webp";